import script from "./RadarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./RadarChart.vue?vue&type=script&setup=true&lang=js"

import "./RadarChart.vue?vue&type=style&index=0&id=073b79cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073b79cc"]])

export default __exports__